import React from 'react';

export const PlusCircle: React.FC = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
    <path
      d="M7.00065 4.66663V9.33329"
      stroke="currentColor"
      strokeWidth="0.875"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.33268 7.00004H4.66602"
      stroke="currentColor"
      strokeWidth="0.875"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 12.25V12.25C4.10025 12.25 1.75 9.89975 1.75 7V7C1.75 4.10025 4.10025 1.75 7 1.75V1.75C9.89975 1.75 12.25 4.10025 12.25 7V7C12.25 9.89975 9.89975 12.25 7 12.25Z"
      stroke="currentColor"
      strokeWidth="0.875"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
